import { Button, Modal } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../hooks/useFetch';
import { IOrder } from '../types/order';

interface IOrdersNotifyServicesButtont {
    disabled?: boolean;
    onNotified: () => void;
    selectedRows: IOrder[];
}

function OrdersNotifyServicesButtont({ disabled, onNotified, selectedRows }: IOrdersNotifyServicesButtont) {
    const notify = useFetch();
    const { t } = useTranslation();

    const onCofirm = async () => {
        await notify.request({
            url: '/orders/notify-third-party-services',
            method: 'post',
            data: { orders: selectedRows.filter((el) => el.paid_data_updated).map((el) => el.id) },
        });
        if (typeof onNotified === 'function') {
            onNotified();
        }
    };

    const notifyServices = async () => {
        Modal.confirm({
            title: t('confirmAction'),
            content: `${t('notifyThirdPartyServiceOrders')} ${selectedRows.filter((el) => el.paid_data_updated).map((el) => el.id)}`,
            onOk: onCofirm,
            okText: t('confirm'),
        });
    };

    return (
        <Button
            disabled={disabled}
            icon={<BellOutlined />}
            onClick={() => notifyServices()}
            loading={notify.loading}
            title={t('paidDataUpdated') as string}
            type="primary"
        >
            {disabled ? '' : t('notifythirdPartyServices')}
        </Button>
    );
}

export default OrdersNotifyServicesButtont;
